import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IAlisFaturacopy_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IAlisFaturacopy_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  NAVIGATE: any;
  NAVIGATE_dummy: any;
  Logout: boolean;
  Logout_dummy: boolean;
  goToSignInActivity: any;
  goToSignInActivity_dummy: any;
  GetInvoicePurchaseVendorCharTotal: any[];
  GetInvoicePurchaseVendorCharTotal_dummy: any[];
  GetInvoicePurchase: any[];
  GetInvoicePurchase_dummy: any[];
  GetVendorAccounts: any[];
  GetVendorAccounts_dummy: any[];
  InvoicePurchaseHeader: any[];
  InvoicePurchaseHeader_dummy: any[];
  GetImage: any[];
  GetImage_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp939690Visible: "visible" | "hidden";
  isComp346579Visible: "visible" | "hidden";
}

export class AlisFaturacopy_ScreenBase extends React.PureComponent<
  IAlisFaturacopy_ScreenProps,
  any
> {
  alisfaturacopy_411475_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfaturacopy_760966_value_kuikaAutoCompleteRef: React.RefObject<any>;
  alisfaturacopy_537989_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfaturacopy_303536_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfaturacopy_209759_value_kuikaSelectBoxRef: React.RefObject<any>;
  alisfaturacopy_888430_value_kuikaTableRef: React.RefObject<any>;
  alisfaturacopy_68619_value_kuikaPaginationRef: React.RefObject<any>;
  ml = [
    {
      Id: "10a0db45-eac7-4ffc-8246-041db2ced344",
      Name: "en_US",
      ShortName: "English",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "1af8c851-1282-4a97-8e96-e652badb345d",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 252560, PropertyName: "label", Value: "Profil" },
        { Id: 442506, PropertyName: "label", Value: "Çıkış Yap" },
        { Id: 809667, PropertyName: "value", Value: "Alış Faturaları" },
        { Id: 411475, PropertyName: "placeholder", Value: "Zaman Aralığı" },
        { Id: 760966, PropertyName: "placeholder", Value: "Tedarikçi" },
        { Id: 927759, PropertyName: "value", Value: "Detaylı Filtrele" },
        { Id: 537989, PropertyName: "placeholder", Value: "Marka" },
        { Id: 303536, PropertyName: "placeholder", Value: "Kategori" },
        { Id: 209759, PropertyName: "placeholder", Value: "Ürün Grubu" },
        { Id: 621226, PropertyName: "value", Value: "Verilen Sipariş" },
        { Id: 887540, PropertyName: "value", Value: "adet" },
        { Id: 93650, PropertyName: "value", Value: "Gelen Sipariş" },
        { Id: 275592, PropertyName: "value", Value: "adet" },
        { Id: 485715, PropertyName: "value", Value: "Kalan Sipariş" },
        { Id: 358902, PropertyName: "value", Value: "adet" },
        { Id: 120870, PropertyName: "value", Value: "Satın Alım Dökümü" },
        { Id: 227219, PropertyName: "value", Value: "Satın Alım Miktar" },
        { Id: 120735, PropertyName: "value", Value: "Satın Alım Tutar" },
        { Id: 259650, PropertyName: "value", Value: "Toplam Satın Alımlar" },
        {
          Id: 550616,
          PropertyName: "value",
          Value: "Marka Bazında Satın Alımlar",
        },
        {
          Id: 888430,
          PropertyName: "nodatafoundmessage",
          Value: "Veri Bulunamadı",
        },
        { Id: 328486, PropertyName: "title", Value: "Title" },
        { Id: 129259, PropertyName: "value", Value: "Fatura No" },
        {
          Id: 77338,
          PropertyName: "value",
          Value: "[datafield:invoicenumber]",
        },
        { Id: 450540, PropertyName: "value", Value: "Tedarikçi Adı" },
        {
          Id: 936610,
          PropertyName: "value",
          Value: "[datafield:vendordescription]",
        },
        { Id: 375257, PropertyName: "value", Value: "Tedarikçi Kodu" },
        { Id: 315184, PropertyName: "value", Value: "[datafield:vendorcode]" },
        { Id: 320295, PropertyName: "value", Value: "Miktar" },
        { Id: 390013, PropertyName: "value", Value: "[datafield:qty1]" },
        { Id: 484923, PropertyName: "value", Value: "Tutar" },
        {
          Id: 176436,
          PropertyName: "value",
          Value: "[datafield:loc_netamount]",
        },
        { Id: 277999, PropertyName: "value", Value: "Tarih" },
        { Id: 445407, PropertyName: "value", Value: "[datafield:invoicedate]" },
      ],
    },
  ];
  defaultML = "en_US";

  screenHash = "";

  constructor(props) {
    super(props);
    this.alisfaturacopy_411475_value_kuikaSelectBoxRef = React.createRef();
    this.alisfaturacopy_760966_value_kuikaAutoCompleteRef = React.createRef();
    this.alisfaturacopy_537989_value_kuikaSelectBoxRef = React.createRef();
    this.alisfaturacopy_303536_value_kuikaSelectBoxRef = React.createRef();
    this.alisfaturacopy_209759_value_kuikaSelectBoxRef = React.createRef();
    this.alisfaturacopy_888430_value_kuikaTableRef = React.createRef();
    this.alisfaturacopy_68619_value_kuikaPaginationRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      NAVIGATE: "",
      Logout: false,
      goToSignInActivity: "",
      GetInvoicePurchaseVendorCharTotal: [],
      GetInvoicePurchase: [],
      GetVendorAccounts: [],
      InvoicePurchaseHeader: [],
      GetImage: [],
      SetValueOf: "",
      dataSource_411475: [
        { key: "1", text: "Bugün" },
        { key: "2", text: "Son 7 Gün" },
        { key: "3", text: "Son 1 Ay" },
        { key: "4", text: "Son 3 Ay" },
        { key: "5", text: "Son  6 Ay" },
        { key: "6", text: "Son 1 Yıl" },
        { key: "7", text: "Tüm Tarihler" },
      ],
      dataSource_537989: [{ value: "Item 1" }, { value: "Item 2" }],
      dataSource_303536: [{ value: "Item 1" }, { value: "Item 2" }],
      dataSource_209759: [{ value: "Item 1" }, { value: "Item 2" }],
      isComp939690Visible: "hidden",
      isComp346579Visible: "hidden",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("alisfaturacopy", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.AlisFaturacopyPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("alisfaturacopy", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("alisfaturacopy", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.AlisFaturacopyPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({});
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  AlisFaturacopyPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(3, "number"),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(3, "number"),
      pageNumber_1: ReactSystemFunctions.convertToTypeByName(1, "number"),
      customerCode_3: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.convertToTypeByName("Hepsi", "string"),
        "string"
      ),
      dateFilter_3: ReactSystemFunctions.convertToTypeByName(3, "number"),
      Id_4: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUserId(),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFaturacopy/AlisFaturacopyPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseVendorCharTotal =
      result?.data.getInvoicePurchaseVendorCharTotal;
    formVars.alisfaturacopy_274639_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );
    formVars.alisfaturacopy_458952_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );
    stateVars.GetInvoicePurchase = result?.data.getInvoicePurchase;

    stateVars.GetVendorAccounts = result?.data.getVendorAccounts;

    formVars.alisfaturacopy_760966_value =
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null;
    formVars.alisfaturacopy_760966_options = stateVars.GetVendorAccounts;
    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfaturacopy_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfaturacopy_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfaturacopy_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    stateVars.GetImage = result?.data.getImage;
    formVars.alisfaturacopy_23176_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturacopyPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturacopyPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    formVars.alisfaturacopy_23176_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetImage !== undefined
        ? stateVars.GetImage?.length > 0
          ? stateVars.GetImage[0].photo
          : null
        : this.state.GetImage?.length > 0
        ? this.state.GetImage[0].photo
        : null
    );

    formVars.alisfaturacopy_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    formVars.alisfaturacopy_760966_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetVendorAccounts !== undefined
        ? stateVars.GetVendorAccounts?.length > 0
          ? stateVars.GetVendorAccounts[0].currAccCode
          : null
        : this.state.GetVendorAccounts?.length > 0
        ? this.state.GetVendorAccounts[0].currAccCode
        : null
    );

    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    stateVars.dataSource_760966 =
      stateVars.GetVendorAccounts ?? this.state.GetVendorAccounts;
    formVars.alisfaturacopy_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfaturacopy_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfaturacopy_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    formVars.alisfaturacopy_274639_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );

    formVars.alisfaturacopy_458952_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_888430 =
      stateVars.GetInvoicePurchase ?? this.state.GetInvoicePurchase;
    formVars.alisfaturacopy_68619_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].totalCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].totalCount
        : null
    );
    formVars.alisfaturacopy_68619_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].pageCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].pageCount
        : null
    );

    formVars.alisfaturacopy_68619_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].totalCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].totalCount
        : null
    );
    formVars.alisfaturacopy_68619_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].pageCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  AlisFaturacopyComponent_548561_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFaturacopy",
      "LeftMenu",
      "",
      "7d969ddf-5801-4eb6-b92b-12be35bdd565",
      "655260",
      null,
      "left",
      "true",
      "100vw",
      "100vh",
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturacopyComponent_252560_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFaturacopy",
      "ProfileScreen",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturacopyComponent_442506_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);
    KuikaAppManager.increaseServerRequestCount();

    stateVars.Logout = await ReactSystemFunctions.logout();
    stateVars.tmpBoolResult = await ReactSystemFunctions.goToSignInActivity(
      this
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturacopyComponent_411475_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFaturacopy/AlisFaturacopyComponent_411475_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfaturacopy_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfaturacopy_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfaturacopy_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    stateVars.GetInvoicePurchaseVendorCharTotal =
      result?.data.getInvoicePurchaseVendorCharTotal;
    formVars.alisfaturacopy_274639_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );
    formVars.alisfaturacopy_458952_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );
    stateVars.GetInvoicePurchase = result?.data.getInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AlisFaturacopyComponent_411475_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturacopyComponent_411475_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "alisfaturacopy_68619_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.alisfaturacopy_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfaturacopy_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfaturacopy_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    formVars.alisfaturacopy_274639_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );

    formVars.alisfaturacopy_458952_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_888430 =
      stateVars.GetInvoicePurchase ?? this.state.GetInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturacopyComponent_760966_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      customerCode_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_2: ReactSystemFunctions.convertToTypeByName(1, "number"),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFaturacopy/AlisFaturacopyComponent_760966_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchaseVendorCharTotal =
      result?.data.getInvoicePurchaseVendorCharTotal;
    formVars.alisfaturacopy_274639_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );
    formVars.alisfaturacopy_458952_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );
    stateVars.InvoicePurchaseHeader = result?.data.invoicePurchaseHeader;
    formVars.alisfaturacopy_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );
    formVars.alisfaturacopy_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );
    formVars.alisfaturacopy_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );
    stateVars.GetInvoicePurchase = result?.data.getInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.AlisFaturacopyComponent_760966_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturacopyComponent_760966_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "alisfaturacopy_68619_value",
        "string"
      ),
      1,
      ReactSystemFunctions.convertToTypeByName("current", "string"),
      false
    );
    formVars.alisfaturacopy_449595_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].orderQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].orderQty1
        : null
    );

    formVars.alisfaturacopy_803416_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].shipmentQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].shipmentQty1
        : null
    );

    formVars.alisfaturacopy_952707_value = ReactSystemFunctions.toString(
      this,
      stateVars.InvoicePurchaseHeader !== undefined
        ? stateVars.InvoicePurchaseHeader?.length > 0
          ? stateVars.InvoicePurchaseHeader[0].remainingQty1
          : null
        : this.state.InvoicePurchaseHeader?.length > 0
        ? this.state.InvoicePurchaseHeader[0].remainingQty1
        : null
    );

    formVars.alisfaturacopy_274639_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].qty1
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].qty1
        : null
    );

    formVars.alisfaturacopy_458952_value = ReactSystemFunctions.toString(
      this,
      stateVars.GetInvoicePurchaseVendorCharTotal !== undefined
        ? stateVars.GetInvoicePurchaseVendorCharTotal?.length > 0
          ? stateVars.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
          : null
        : this.state.GetInvoicePurchaseVendorCharTotal?.length > 0
        ? this.state.GetInvoicePurchaseVendorCharTotal[0].loc_NetAmount
        : null
    );

    stateVars.dataSource_888430 =
      stateVars.GetInvoicePurchase ?? this.state.GetInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturacopyComponent_965991_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "ToplamSatinAlim",
      "CustomerCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "ToplamSatinAlim",
      "dateFilter",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFaturacopy",
      "ToplamSatinAlim",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturacopyComponent_507288_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    KuikaAppManager.prepareForNavigation();
    KuikaAppManager.addToPageInputVariables(
      "MarkaSecSatinAlma",
      "VendorName",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccDescription"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MarkaSecSatinAlma",
      "VendorCode",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      )
    );
    KuikaAppManager.addToPageInputVariables(
      "MarkaSecSatinAlma",
      "dateFilter",
      ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      )
    );

    stateVars.NAVIGATE = await ReactSystemFunctions.navigate(
      this,
      undefined,
      "AlisFaturacopy",
      "MarkaSecSatinAlma",
      "",
      "currentPage",
      null,
      null,
      null,
      null,
      null,
      null,
      true,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  AlisFaturacopyComponent_68619_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      customerCode_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_760966_value",
            "value",
            "GetVendorAccounts",
            "currAccCode",
            "currAccCode"
          )
        ),
        "string"
      ),
      dateFilter_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toInteger(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_411475_value",
            "value",
            "",
            "key",
            ""
          )
        ),
        "number"
      ),
      pageNumber_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "alisfaturacopy_68619_value",
            "current",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "AlisFaturacopy/AlisFaturacopyComponent_68619_onChange",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.GetInvoicePurchase = result?.data.getInvoicePurchase;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.AlisFaturacopyComponent_68619_onChange1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  AlisFaturacopyComponent_68619_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_888430 =
      stateVars.GetInvoicePurchase ?? this.state.GetInvoicePurchase;
    formVars.alisfaturacopy_68619_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].totalCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].totalCount
        : null
    );
    formVars.alisfaturacopy_68619_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].pageCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].pageCount
        : null
    );

    formVars.alisfaturacopy_68619_total = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].totalCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].totalCount
        : null
    );
    formVars.alisfaturacopy_68619_pageSize = ReactSystemFunctions.value(
      this,
      stateVars.GetInvoicePurchase !== undefined
        ? stateVars.GetInvoicePurchase?.length > 0
          ? stateVars.GetInvoicePurchase[0].pageCount
          : null
        : this.state.GetInvoicePurchase?.length > 0
        ? this.state.GetInvoicePurchase[0].pageCount
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [655260, ,] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.AlisFaturacopyPageInit();
    }
  }
}
